import { render, staticRenderFns } from "./firmaemail.vue?vue&type=template&id=70bd79ea&"
import script from "./firmaemail.vue?vue&type=script&lang=js&"
export * from "./firmaemail.vue?vue&type=script&lang=js&"
import style0 from "./firmaemail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports